export class GWCoverage {
    public id: number;
    public quoteId: number;
    public externalRatingId: string;
    public selectedLimit: number;
    public type: string;
    public premium: number;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/agents-gateway/save-quote/gw-coverage.model.ts